<template>
  <div class="electron-note-header electron-drag">
    <span class="text-deEmphasised-text">{{ translate('autoSaved') }}</span>
    <div
      class="flex items-center h-6 px-2 gap-x-1 cursor-pointer hover:bg-hover-default rounded electron-no-drag"
      @click="seeAllNotes"
    >
      <em
        class="custom-icons"
        :style="getCustomIconStyle(iconPath('note'))"
      />
      <span class="text-text-default">{{ translate('seeAllNotes') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';

const { iconPath, getCustomIconStyle } = useCustomIcon();
const { translate } = useTranslate();

const seeAllNotes = () => {
  //@ts-ignore
  window.electron.send('change-route-channel', {
    path: 'notes',
    closeCard: true, // closes card when opening new route
  });
};
</script>

<style lang="scss">
.electron-note-header {
  @apply min-h-12 items-center flex flex-row gap-x-2 px-2 justify-end;

  span {
    @apply text-sm;
  }
}
</style>
